/* eslint-disable */
import { MODULE_NAME, } from './../constants';

export const GET_TRANSACTIONS = `${MODULE_NAME}/GET_TRANSACTIONS`;
export const GET_TRANSACTIONS_SUCCESS = `${MODULE_NAME}/GET_TRANSACTIONS_SUCCESS`;
export const GET_TRANSACTIONS_ERROR = `${MODULE_NAME}/GET_TRANSACTIONS_ERROR`;
